<template>    
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>						
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Estoque:</span>
                                <select id="cbestoquepesq" v-model="pidestoquepesc"
                                        data-placeholder="Selecione o estoque" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div> 
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Em digitação</option>
                                    <option value="1">Finalizada</option>
                                    <option value="2">Todas</option>
                                </select>
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbfiltropor">Por:</label>
                                <select class="form-control form-control-sm" id="cbfiltropor" v-model="ppor" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()">
                                    <option value="0">Dt. Início</option>
                                    <option value="1">Dt. Efetivação</option>
                                </select>
                            </div> 							
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>    
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstconferencias"
                                        :rows="lstconferencias"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 0" class="badge badge-pill badge-primary" style="background: #646dd4;">Em edição</span>
                                        <span v-else class="badge badge-pill badge-primary" style="background: #5a956a;">Finalizada</span>                                        
                                    </template>                                    
                                    <template slot="slot_opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)" title="Alterar"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)" title="Excluir"><i class="fa fa-trash"></i></button>
                                        <button type="button" class="btn btn-secondary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdefetivacao(item.row)" title="Efetivar conferência"><i class="fa fa-check"></i></button>
                                        <button type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtddetalhes(item.row)" title="Detalhes da conferência"><i class="fa fa-info"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstconferencias.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-6 col-sm-6 col-md-8 col-lg-8" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block btn_ajusta_top" @click.prevent="mtdagrupar()"><i class="fa fa-object-group" title="Agrupa as transferências selecionadas gerando uma nova"></i> Agrupar</button>
                            </div>                            
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block btn_ajusta_top" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Layout arquivo de importação de estoques" style="margin-right: 10px;" @click.prevent="mtdbaixarmatriz()"><span aria-hidden="true"><i class="fa fa-file-excel-o"></i></span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-3">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa" class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">*Estoque:</span>
                                <select id="cbestoque" data-placeholder="Selecione estoque origem" v-bind:disabled="ativadesativa" v-model="videstoque" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                        
                            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2" style="padding-top: 21px;">                            
                                <div class="custom-control custom-switch border rounded" style="margin-top: -2px;padding: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cblancarauto" v-model="lancarauto" v-bind:disabled="ativadesativa">
                                    <label class="custom-control-label" for="cblancarauto" id="lbllancarauto" style="margin-left: 40px;">Lançar unitário</label>
                                </div>
                            </div>                        
							<div class="col-sm-12 col-md-2 col-lg-2">
                                <input type="file" id="btselecionararquivo" accept=".xls" style="display: none;">
                                <button type="button" @click.prevent="mtdarquivoconferencia()" class="btn btn-primary btn-sm btn-block"
                                        style="margin-top: 20px;" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-file"></i> Selecionar arquivo
                                </button>
							</div>                                                        
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">ITENS DA CONFERÊNCIA</div>
                                    <div class="card-body">
                                        <div v-show="parseInt(opcrud) < 3" class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-2">
                                                <label for="edidproduto">Produto:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <div style="position: left;" id="dv-btn-camera" class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdscannearcode()" title="Ler código de barras com a câmera"><i class="fa fa-barcode" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                    <input type="text" class="form-control form-control-sm" id="edidproduto" v-model="vcoddig" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddig)" v-on:keyup.13="mtdlocalizarproduto(vcoddig)" style="text-transform: uppercase;">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-7 col-lg-6">
                                                <label for="eddescricaoproduto">Descrição do produto:</label>
                                                <input type="text" class="form-control form-control-sm" id="eddescricaoproduto" v-model="vdescricaoproduto" maxlength="100" style="font-weight: bold;" disabled>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">

                                                <label for="edqtditem">Quantidade:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdquantidadeconf(2)"><i class="fa fa-minus"></i></a>
                                                    </div>
                                                    <money type="text" class="form-control form-control-sm" id="edqtditem"  v-on:keyup.13="mtdincluiritem()" v-model="vqtditem" data-bv-group=".group" maxlength="20" style="text-align:right;" ></money>
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdquantidadeconf(1)"><i class="fa fa-plus"></i></a>
                                                    </div>
                                                </div>
                                                <!-- <money type="text" class="form-control form-control-sm" id="edqtditem" v-model="vqtditem" data-bv-group=".group" maxlength="20" style="text-align:right;"></money> -->
                                            </div>
                                            <div class="col-md-2">
                                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdincluiritem()" style="margin-top: 20px;"><i class="fa fa-plus"></i> Incluir</button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table ref="reflstitens"
                                                        :rows="lstitens"
                                                        :columns="columnsitens"
                                                        :config="configitens"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                                    
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                    <template slot="slot_codigo" slot-scope="item">
                                                        <span style="font-weight: 600;">{{ item.row.coddig }}</span>
                                                    </template>
                                                    <template slot="slot_qtditem" slot-scope="item">
                                                        <span @click.prevent="mtdalterarqtd(item.row, false, 1)"><i class="op-qtd op-qtd-ret fa fa-minus-circle"></i></span>
                                                        <span style="font-weight: 600;">{{ item.row.qtditem }}</span>
                                                        <span @click.prevent="mtdalterarqtd(item.row, true, 1)"><i class="op-qtd op-qtd-acres fa fa-plus-circle"></i></span>
                                                    </template>                                                    
                                                </vue-bootstrap4-table>
                                            </div>                                                                                        
                                        </div>
                                    </div>
                                </div>        
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal para efetivação da conferência -->
        <div class="modal fade" id="mdlefetivacao" tabindex="-1" role="dialog" aria-labelledby="mdlefetivacaotitulo" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 v-if="efetivacao" class="modal-title"><i class="fa fa-check"></i> Efetivação de conferência</h5>
                <h5 v-else class="modal-title"><i class="fa fa-check"></i> Detalhes da conferência</h5>        
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
               <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="alert alert-primary" role="alert">
                            <span style="color: #666666; font-weight: 600;"><strong>{{eid}}</strong> - {{edescricao}} <strong title="Estoque da conferência">({{eidestoque}} - {{edescestoque}})</strong></span>
                            <template v-if="!efetivacao">
                                <span v-if="parseInt(esituacao) === 0" class="badge badge-pill badge-primary" style="background: #646dd4; float: right; font-size: 12px;">Em edição</span>
                                <span v-else class="badge badge-pill badge-primary" style="background: #5a956a; float: right;  font-size: 12px;">Finalizada</span>                                        
                            </template>
                        </div>                                                                
                    </div>                   
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <table class="table table-bordered table-sm table-hover">
                                <!--Luiz Trindade - Cabeçalho da tabela-->
                                <thead class="thead-light">
                                    <tr style="font-weight: 600;">
                                        <th>Item:</th>
                                        <th>Código:</th>
                                        <th>Descrição:</th> 
                                        <th>Setor:</th>
                                        <th>Conferida:</th>
                                        <th>Estoque:</th>

                                        <!--Luiz Trindade - Adição do total de custo-->
                                        <th>Tot. custo est.:</th>
                                        
                                        <!--Luiz Trindade - Adição do total de custo conferido-->
                                        <th>Custo conferido:</th>
                                        
                                        <th style="text-align: center;">Ajustar:</th>
                                        
                                        <!--Luiz Trindade - Adição da diferença-->
                                        <th>Diferença:</th>
                                    </tr>
                                </thead>

                                <!--Luiz Trindade - Corpo da tabela-->
                                <tbody>
                                    <tr v-for="(item, index) in elstitens" v-bind:key="index">
                                        <td style="font-weight: 600; width: 50px;">{{ item.item }}</td>
                                        <td style="font-weight: 600;">{{ item.coddig }}</td>
                                        <td style="font-weight: 600;">{{ item.descproduto }}</td>
                                        <td style="font-weight: 600;">{{ item.descsetor }}</td>
                                        <td style="text-align: right; font-weight: 600;">
                                            {{mtdformatavalordecimal(parseFloat(item.qtditem), 3)}}
                                        </td>
                                        <template v-if="parseInt(esituacao) === 0">
                                            <td style="text-align: right; font-weight: 600;">
                                                {{mtdformatavalordecimal(parseFloat(item.qtdestoque), 3)}}
                                            </td> 
                                            
                                            <!--Luiz Trindade - Total de custo-->
                                            <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.totalcusto), 2)}}</td>

                                            <!--Luiz Trindade - Total de custo conferido-->
                                            <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.prcusto * item.qtditem), 2)}}</td>
                                            
                                            <td style="text-align: right; width: 130px;">
                                                <span v-if="parseFloat(item.qtdajustar) > 0" class="badge badge-primary badge-pill badge-item-resultado">
                                                    {{mtdformatavalordecimal(parseFloat(item.qtdajustar), 3)}}
                                                </span>
                                                <span v-else-if="parseFloat(item.qtdajustar) < 0" class="badge badge-danger badge-pill badge-item-resultado">
                                                    {{mtdformatavalordecimal(parseFloat(item.qtdajustar), 3)}}
                                                </span>                                                
                                                <span v-else class="badge badge-secondary badge-pill badge-item-resultado">
                                                    {{mtdformatavalordecimal(parseFloat(item.qtdajustar), 3)}}
                                                </span>                                                                                       
                                            </td>     

                                            <!--Luiz Trindade - Diferença-->
                                            <td style="text-align: right;">
                                                {{ mtdformatavalordecimal(parseFloat((item.prcusto * item.qtditem) - item.totalcusto), 2) }}
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td style="text-align: right; font-weight: 600;">
                                                {{mtdformatavalordecimal(parseFloat(item.qtdestoquedia), 3)}}
                                            </td>   
                                            
                                            <!--Luiz Trindade - Total de custo dia-->
                                            <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.totalcusto), 2)}}</td>

                                            <!--Luiz Trindade - Total de custo conferido-->
                                            <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.prcusto * item.qtditem), 2)}}</td>

                                            <td style="text-align: right; width: 130px;">
                                                <span v-if="parseFloat(item.qtdajustar) > 0" class="badge badge-primary badge-pill badge-item-resultado">
                                                    {{mtdformatavalordecimal(parseFloat(item.qtdajustar), 3)}}
                                                </span>
                                                <span v-else-if="parseFloat(item.qtdajustar) < 0" class="badge badge-danger badge-pill badge-item-resultado">
                                                    {{mtdformatavalordecimal(parseFloat(item.qtdajustar), 3)}}
                                                </span>                                                
                                                <span v-else class="badge badge-secondary badge-pill badge-item-resultado">
                                                    {{mtdformatavalordecimal(parseFloat(item.qtdajustar), 3)}}
                                                </span>                                                                                       
                                            </td>      
                                            
                                            <!--Luiz Trindade - Diferença-->
                                            <td style="text-align: right;">
                                                {{ mtdformatavalordecimal(parseFloat((item.prcusto * item.qtditem) - item.totalcusto), 2) }}
                                            </td>
                                        </template>                                                                                           
                                    </tr>
                                </tbody>
                            </table>
                        </div>                        
                    </div>
                    <div class="col-md-12">
                        <ul class="list-group" v-if="elstitens.length > 0">
                            <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                <span style="font-weight: 600;">Conferidos</span>
                                <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{elstitens.length}}</span>
                            </li>

                            <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                <span style="font-weight: 600;">Total Estoque</span>
                                <span class="badge badge-primary badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(mtdgerartotalest(1)), 3)}}</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                <span style="font-weight: 600;">Total Conferências</span>
                                <span class="badge badge-secondary badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(mtdgerartotalest(2)), 3)}}</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                <span style="font-weight: 600;">Total Custo Conferido</span>
                                <span class="badge badge-primary badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(mtdgerartotalest(3)), 2)}}</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                <span style="font-weight: 600;">Total Diferença</span>
                                <span class="badge badge-secondary badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(mtdgerartotalest(4)), 2)}}</span>
                            </li>
                        </ul>      
                    </div>              
                </div>
            </div>
            <div class="modal-footer" style="padding: 10px 0px 0px 0px;">
                <div class="container-fluid">
                    <div v-show="efetivacao" class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="alert alert-danger">
                                <strong>Atenção!</strong> Ao marcar a opção abaixo, você irá <strong>zerar</strong> o estoque de todos os produtos que não estiverem nesta contagem. Só marque se tiver certeza!
                            </div>                
                        </div>
                        <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8" style="padding-top: 8px; padding-bottom: 10px;">                            
                            <div class="custom-control custom-switch border rounded" style="margin-top: -5px; padding: 5px;">
                                <input type="checkbox" class="custom-control-input" id="cbzerar" v-model="ezerarforaconf">
                                <label class="custom-control-label" for="cbzerar" id="lblzerar" style="margin-left: 40px;">Zerar itens fora da conferência</label>
                            </div>
                        </div> 				
                        <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">																						                
                            <button type="button" class="btn btn-primary btn-block" @click.prevent="mtdconfirmaefetivacao()"><i class="fa fa-check"></i> Efetivar</button>                
                        </div>
                        <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">																						                
                            <button type="button" class="btn btn-secondary btn-block" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>                
                        </div>
                    </div>    
                    <div v-show="!efetivacao" class="row" style="margin-bottom: 10px;">
                        <div class="col-sm-12 col-md-9 col-lg-9 col-xl-9">
                        </div>
                        <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">																						                
                            <button type="button" class="btn btn-secondary btn-sm btn-block" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>                
                        </div>                    
                    </div>
                </div>    
            </div>
            </div>
        </div>
        </div>
        <!-- Modal do scannercode -->        
        <div class="modal static" id="mdlscannercode"  >
            <div class="modal-dialog modal-lg static">
                <div class="modal-content">         
                    <div id="#dvcamera">
                        <v-quagga v-if="mostrandomodal==true" :onDetected="mtdprocessacodbar" :readerSize="readerSize" 
                            :readerTypes="
                            ['code_128_reader',
                            'ean_reader', 
                            'ean_8_reader']">
                        </v-quagga>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal para visualização dos itens não encontrados -->        
        <div class="modal fade" id="mdlnaoencontrados">
            <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-exclamation-triangle"></i> Itens não encontrados</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
					<div class="row">
							<div class="col-md-12">
								<div class="table-responsive">
									<table class="table table-bordered table-sm table-hover">
										<thead class="thead-light">
											<tr style="font-weight: 600;">
												<th>Código:</th>
												<th>Quantidade:</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in lstitensnaoencontrados" v-bind:key="index">
												<td style="font-weight: 600;">{{ item.id }}</td>
												<td style="text-align: right; font-weight: 600;">
													{{mtdformatavalordecimal(parseFloat(item.qtditem), 3)}}
												</td>                                                           
											</tr>
										</tbody>
									</table>
								</div>                        
							</div>                
					</div>					
                </div>            
                <div class="modal-footer">
                	<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                </div>                
            </div>
            </div>
        </div>
    </div>    
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import util from '../utilitarios/util.js'
    import VueQuagga from 'vue-quaggajs'
    

    export default {        
        name: 'cadconferencias',
        components:{
            VueBootstrap4Table,
            vPagination,
            VueQuagga,
            'breadcrumb' : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos
        },
        data: function() {
            return {
                //variáveis do leitor de código de barras
                mostrandomodal      : false, 
                readerSize: {
                    width: 640,
                    height: 480
                },
                detecteds           : [],

                //variáveis para a consulta de produtos
                vshowprtabela		: false,
                vidtabela           : null,
                tipopropesquisa     : '',
                
                
                lstconferencias     : [],
                pfiltro             : 1,
                pfiltroperiodo      : 1,
                ppor                : 0,
                pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),	
                pidestoquepesc      : null,	
                pconteudo           : '',
                psituacao           : 2,   
                pqtdregistros       : 10,
                pqtd_paginas        : 1,
                pagina_atual        : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                videstoque          : null,
                lancarauto          : false,

                //variaveis da conferência
                lstitens            : [],
                lstitensnaoencontrados: [],
                vitem               : 0,
                vcoddig             : '',
                vidproduto			: '',
                vdescricaoproduto 	: '',
                vundproduto			: '',
                vqtditem            : 1,
                vfracionado			: '',
                vnomearquivo        : '',

                //variaveis efetivacao
                efetivacao          : false,
                eid                 : '',
                esituacao           : 0,
                edescricao          : '',
                eidestoque          : 0,
                edescestoque        : '',
                elstitens           : [],
                ezerarforaconf      : false,

                //variável para habilitação dos campos
                ativadesativa       : true,

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'CONFERÊNCIAS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        slot_name: 'slot_opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-conferencia",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod"
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-descricao"
                    },
                    {
                        label: "Estoque",
                        name: "descestoque",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-descestoque"
                    },                    
                    {
                        label: "Início",
                        name: "dtinicio",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-dtinicio"
                    },
                    {
                        label: "Situação",
                        name: "situacao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao"
                    },
                    {
                        label: "Efetivação",
                        name: "dttermino",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-finalizacao"
                    },
                    {
                        label: "Usu. efetiva",
                        name: "nomeusu",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomeusu"
                    }
                ],
                columnsitens: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-item",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        sort: true,
                        slot_name: "slot_item",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "slot_codigo",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descproduto",
                        sort: true,
                        slot_name: "slot_descpro",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    },
                    {
                        label: "Qtd",
                        name: "qtditem",
                        sort: true,
                        slot_name: "slot_qtditem",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-qtd-item",
                    },
                    {
                        label: "Und",
                        name: "unditem",
                        sort: true,
                        slot_name: "slot_unditem",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-und-item",
                    }
                ],                             
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                configitens: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },                 
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdquantidadeconf(op){
				if (parseInt(op) === 1){
					this.vqtditem++;
				}else{
					if (parseFloat(this.vqtditem) > 1){
						this.vqtditem--;
					}
				}
			},
            mtdgerartotalest(op){
                let totalmostrar = 0;
                switch (op) {
                    case 1:
                        for (let index = 0; index < this.elstitens.length; index++) {
                            totalmostrar = totalmostrar + parseFloat(this.elstitens[index].totalestoque);
                        }
                        
                        break;
                    case 2:
                        for (let index = 0; index < this.elstitens.length; index++) {
                            totalmostrar = totalmostrar + parseFloat(this.elstitens[index].totalconferencia);
                        }
                        break; 
                    case 3:
                        for (let index = 0; index < this.elstitens.length; index++) {
                            totalmostrar = totalmostrar + parseFloat(this.elstitens[index].totalcustoconferido);
                        }
                        break;
                    case 4:
                        for (let index = 0; index < this.elstitens.length; index++) {
                            totalmostrar = totalmostrar + parseFloat(this.elstitens[index].totaldiferenca);
                        }
                        break;                                               
                }
                return totalmostrar; 
            },
            mtdprocessacodbar(data){
                var codpro = data.codeResult.code
                this.vcoddig = codpro;
                this.mtdlocalizarproduto(parseInt(codpro))
                this.mtdescondescanner();
            },
            mtdscannearcode(){
                $("#mdlscannercode").modal('show');
                this.mostrandomodal = true
            },
            mtdescondescanner(){
                $("#mdlscannercode").modal('hide');
                this.mostrandomodal = false
            },
            mtdformatavalordecimal(valor, digitos){
                return util.formatavalordecimais(valor, digitos);
            },
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},            
            mtddefinial(){
                let vself = this;

                $('#mdlscannercode').on('hide.bs.modal', function (e) {
                    vself.mostrandomodal = false
                });  

                $("#cbestoquepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidestoquepesc = $("#cbestoquepesq").val();
				});              

				$("#cbestoque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoque = $("#cbestoque").val();
				});
                $('#btselecionararquivo').change(function() {
                    vself.mtdrotinaferencia();
                });                 
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and c.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(c.descricao) like upper("'+this.pconteudo+'%")';
                }
                if (parseInt(this.psituacao) < 2){
                    rfiltro = rfiltro + ' and c.situacao='+this.psituacao;
                }
                if(parseInt(this.pfiltroperiodo) === 1){
                    let strpor = parseInt(this.ppor) === 0 ? 'dtinicio' : 'dttermino';
					rfiltro = rfiltro + ' and c.'+strpor+' between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                }
                if(this.pidestoquepesc !== null){
                    rfiltro = rfiltro + ' and c.idestoque='+this.pidestoquepesc;
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadconferencias.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaconferencias(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregaconferencias(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                vself.$refs.reflstconferencias.selected_items = [];//limpa os ítens selecionados na table 
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadconferencias.php');
                retorno.then(function (response) {
                    vself.lstconferencias = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstconferencias = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                = '';
                this.vdescricao         = '';
                this.videstoque         = null;
                this.lancarauto         = false;

                this.lstitens           = [];
                this.vitem              = 0;
                this.vidproduto			= '';
                this.vcoddig            = '';
                this.vdescricaoproduto 	= '';
                this.vundproduto		= '';
                this.vqtditem           = 1;
                this.vfracionado		= ''; 
                
                $("#cbestoque").val(null).trigger('change');

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('010Z.030Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE CONFERÊNCIA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstconferencias = [];
                this.$refs.reflstconferencias.selected_items = [];//limpa os ítens selecionados na table                 
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and c.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadconferencias.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('010Z.030Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (parseInt(item.situacao) === 1 ){
                        this.$toastr.i('Conferência já finalizada, impossível realizar esta operação!', 'Informação!');
                        return;
                    }                         
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE CONFERÊNCIA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('010Z.030Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (parseInt(item.situacao) === 1 ){
                        this.$toastr.i('Conferência já finalizada, impossível realizar esta operação!', 'Informação!');
                        return;
                    }                           
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE CONFERÊNCIA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vdescricao          = registro.descricao;
                this.lstitens            = registro.itens;
                this.lancarauto 		 = parseInt(registro.lancarauto) === 0 ? false : true;

                this.vitem               = this.lstitens[this.lstitens.length - 1].item;

                var defestoque = new Option(registro.descestoque, registro.idestoque, true, true);
                $('#cbestoque').append(defestoque).trigger('change');                                                                    
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'idestoque'         : this.videstoque,
                    'lancarauto'		: this.lancarauto === false ? 0 : 1,
                    'itens'             : this.lstitens
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '010Z.030Z.010Z' : parseInt(this.opcrud) === 2 ? '010Z.030Z.020Z' : '010Z.030Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadconferencias.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.ppor           = 0;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaconferencias(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.vidproduto			= produto.id;
							vself.vdescricaoproduto 	= produto.descricao;
							vself.vundproduto			= produto.und;
                            vself.vfracionado			= produto.fracionado;

                            if (vself.lancarauto){
                                let indiceitem = util.getArrayIndexForKey(vself.lstitens, 'idproduto', vself.vidproduto);

                                vself.vitem++;                         

                                let itemtmp = {
                                    idproduto		    : vself.vidproduto,
                                    descproduto		    : vself.vdescricaoproduto,
                                    coddig			    : vself.vcoddig,
                                    item			    : vself.vitem,
                                    qtditem			    : vself.vqtditem,
                                    unditem			    : vself.vundproduto
                                };

                                if (parseInt(vself.vfracionado) === 0){
                                    if (!Number.isInteger(vself.vqtditem)){
                                        vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                                        $('#edqtditem').focus();
                                        return;
                                    }
                                }                                                

                                if (indiceitem !== -1){
                                    itemtmp.item = indiceitem;                                   
                                    vself.mtdalterarqtd(itemtmp, true, itemtmp.qtditem);								
                                }else{
                                    vself.mtdlancaitem(itemtmp);
                                }
                                setTimeout(() => {
                                    vself.vidproduto          = '';
                                    vself.vdescricaoproduto   = '';
                                    vself.vcoddig             = '';
                                    vself.vqtditem            = 1;                                    
                                    $('#edidproduto').focus();                                                                                                                      
                                }, 200);                                 
                            }else{
                                vself.$nextTick(function () {
                                    $('#edqtditem').focus();
                                });
                            }
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.vidproduto			= '';
							vself.vdescricaoproduto 	= '';
							vself.vundproduto			= '';
                            vself.vfracionado			= '';
							$('#edidproduto').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
                    vself.vidproduto			= '';
                    vself.vdescricaoproduto 	= '';
                    vself.vundproduto			= '';
                    vself.vfracionado			= '';
				}
            },        
            mtdconsultarproduto(){
				if (parseInt(this.opcrud) < 3){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
            mtdincluiritem(){
                let vself = this;
                if (vself.vcoddig === ''){                    
                    vself.$toastr.w('Código do produto deve ser informado!', 'Informação!');
                    $('#edidproduto').focus();
                    return;
                }
                if (parseFloat(vself.vqtditem) <= 0){                    
                    vself.$toastr.w('Quantidade inválida!', 'Informação!');
                    $('#edqtditem').focus();
                    return;
                }                
                if (parseInt(vself.vfracionado) === 0){
                    if (!Number.isInteger(vself.vqtditem)){
						vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditem').focus();
                        return;
                    }
                }

                let indiceitem = util.getArrayIndexForKey(vself.lstitens, 'idproduto', vself.vidproduto);
                vself.vitem++;

                let itemtmp = {
                    idproduto		    : vself.vidproduto,
                    descproduto		    : vself.vdescricaoproduto,
                    coddig			    : vself.vcoddig,
                    item			    : vself.vitem,
                    qtditem			    : vself.vqtditem,
                    unditem			    : vself.vundproduto
                };                
                if (indiceitem !== -1){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Produto já lançado na conferência. Deseja adicionar a quantidade?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true); 
                                    itemtmp.item = indiceitem;                                   
                                    vself.mtdalterarqtd(itemtmp, true, itemtmp.qtditem);

                                    vself.vidproduto          = '';
                                    vself.vdescricaoproduto   = '';
                                    vself.vcoddig             = '';
                                    vself.vqtditem            = 1;
                                    setTimeout(() => {
                                        $('#edidproduto').focus();                                                                                                                      
                                    }, 500);                                  
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {                                
                                    vself.vidproduto          = '';
                                    vself.vdescricaoproduto   = '';
                                    vself.vcoddig             = '';
                                    vself.vqtditem            = 1;                                             
                                    setTimeout(() => {
                                        $('#edidproduto').focus();                                                                                                                      
                                    }, 500);
                                    
                                }
                            }
                        }
                    });                    
                }else{
                    vself.mtdlancaitem(itemtmp);
                }                                
            },            
            mtdlancaitem(itemtmp){
                let vself = this;
                vself.lstitens.push(itemtmp);    
                vself.vidproduto          = '';
                vself.vdescricaoproduto   = '';
                vself.vundproduto         = '';  
                vself.vcoddig             = '';
                vself.vqtditem            = 1;
                $('#edidproduto').focus();                
            },
            mtdexcluiritem(item){
                let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'item', item.item);

                this.lstitens.splice(indiceitem, 1);                
            },
            mtdalterarqtd(item, aumentar, qtd){
                if (parseInt(this.opcrud) < 3){
                    let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'idproduto', item.idproduto);                
                    if (aumentar) {
                        this.lstitens[indiceitem].qtditem+=parseFloat(qtd);
                    }else{
                        if (parseFloat(this.lstitens[indiceitem].qtditem) > 1){
                            this.lstitens[indiceitem].qtditem-=parseFloat(qtd);
                        }else{
                            return;
                        }
                    }    
                }
            },
            mtdagrupar(){
                let vself = this;
                if (!util.opcaousuario('010Z.030Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    let lstitensagrupados = [];
                    let lstestoques       = [];
                    var lstitensselecionados = [];
                    let it = 0;
                    //converti pra string depois de volta pra json pq estava herdando todo tempo as alterações
                    lstitensselecionados = JSON.parse(JSON.stringify(vself.$refs.reflstconferencias.selected_items));

                    if (lstitensselecionados.length > 1){
                        for (let i = 0; i < lstitensselecionados.length; i++) {
                            const conf = lstitensselecionados[i]; 
                            let estoquetmp = {
                                idestoque  : conf.idestoque,
                                descestoque: conf.descestoque
                            };
                            let ie = util.getArrayIndexForKey(lstestoques, 'idestoque', estoquetmp.idestoque);
                            if (ie === -1){
                                lstestoques.push(estoquetmp);
                            }
                            if (parseInt(conf.situacao) === 0){                                    
                                for (let x = 0; x < conf.itens.length; x++) {
                                    const item = conf.itens[x];                                    
                                    let inditem = util.getArrayIndexForKey(lstitensagrupados, 'idproduto', item.idproduto);
                                    if (inditem === -1){
                                        it++;
                                        item.item = it;
                                        lstitensagrupados.push(item);                                        
                                    }else{
                                        lstitensagrupados[inditem].qtditem = parseFloat(lstitensagrupados[inditem].qtditem) + parseFloat(item.qtditem);                                            
                                    }                            
                                }
                            }else{
                                vself.$toastr.w('Selecione apenas conferências em digitação!', 'Informação!');  
                                return;
                            }
                        }
                        if (lstestoques.length > 1){
                            vself.$toastr.w('Selecione apenas conferências com o mesmo estoque!', 'Informação!');  
                            return;
                        }else{
                            this.itensbc.item2.titulo = 'INCLUSÃO DE CONFERÊNCIA';
                            this.itensbc.item1.ativo = true;
                            this.itensbc.item2.ativo = true;
                            this.ativadesativa = false;
                            this.mtdpreparacrud(1);
                            setTimeout(() => {
                                vself.lstitens = lstitensagrupados;
                                var defestoque = new Option(lstestoques[0].descestoque, lstestoques[0].idestoque, true, true);
                                $('#cbestoque').append(defestoque).trigger('change');                                      
                            }, 200);
                        }
                    }else{
                        vself.$toastr.w('Selecione ao menos duas ou mais conferências a serem agrupadas!', 'Informação!'); 
                    }                        
                }                        
            },
            mtdefetivacao(conferencia){                
                let vself               = this;                
                if (!util.opcaousuario('010Z.030Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    if (parseInt(conferencia.situacao) === 1){
                        vself.$toastr.w('Conferência já efetivada!', 'Atenção!'); 
                        return;
                    }
                    vself.efetivacao        = true;
                    vself.eid               = conferencia.id;
                    vself.esituacao         = conferencia.situacao;
                    vself.edescricao        = conferencia.descricao;
                    vself.eidestoque        = conferencia.idestoque;
                    vself.edescestoque      = conferencia.descestoque;
                    vself.ezerarforaconf    = false;
                    let loader = vself.$loading.show();
                    let parametros          = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',            valor : 'resultados'},
                        {parametro: 'idconferencia', valor : conferencia.id},
                        {parametro: 'idestoque',     valor : conferencia.idestoque}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadconferencias.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if ($.isNumeric(response.data.ret)){
                            vself.elstitens = response.data.itens;
                            $('#mdlefetivacao').modal('show');
                        }else{
                            let tpret = response.data.ret.substring(0,1);
                            switch (tpret) {
                                case 'I':
                                    vself.$toastr.w(response.data.ret.substring(4), 'Atenção!');
                                    break;
                                case 'E': default:
                                    vself.$toastr.e(response.data.ret.substring(4), 'Erro!');
                                    break;
                            }
                        }
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao carregar dados da conferência. Descrição do erro: '+response.message, 'Erro!');
                    });                                
                }                            
            },
            mtdconfirmaefetivacao(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'O processo de ajuste do estoque pode demorar alguns minutos. Deseja mesmo continuar com a Efetivação?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);                                
                                let loader = vself.$loading.show();
                                let parametros          = [
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',            valor : 'efetivar'},
                                    {parametro: 'idconferencia', valor : vself.eid},
                                    {parametro: 'idestoque',     valor : vself.eidestoque},
                                    {parametro: 'zerarfora',     valor : !vself.ezerarforaconf ? 0 : 1},
                                    {parametro: 'idfilial',      valor : vself.$store.state.filialpadrao.codfil},
                                    {parametro: 'idusuario',     valor : vself.$store.state.usuario.id}
                                ];
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadconferencias.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    if ($.isNumeric(response.data)){                                            
                                        vself.$toastr.s("Conferência efetivada com sucesso!", 'Atenção!');
                                        $('#mdlefetivacao').modal('hide');
                                        vself.efetivacao    = false;
                                        vself.pfiltro       = 0;
                                        vself.pconteudo     = vself.eid;
                                        vself.pqtd_paginas  = 1;
                                        vself.mtdcancelaredicao();
                                        vself.mtdcarregaconferencias(1);
                                    }else{                                            
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                break;
                                            case 'E': default:
                                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                break;
                                        }
                                    }
                                }).catch(function (response) {                                        
                                    loader.hide();
                                    vself.efetivacao = false;
                                    vself.$toastr.e('Erro ao carregar dados da conferência. Descrição do erro: '+response.message, 'Erro!');
                                    $('#mdlefetivacao').modal('hide');
                                });                                                                
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });              
            },
            mtddetalhes(conferencia){                
                let vself = this;
                if (parseInt(conferencia.situacao) === 0){
                    vself.$toastr.i('Conferência não finalizada!', 'Atenção!');
                    return;
                }
                vself.efetivacao        = false;
                vself.eid               = conferencia.id;
                vself.esituacao         = conferencia.situacao;
                vself.edescricao        = conferencia.descricao;
                vself.eidestoque        = conferencia.idestoque;
                vself.edescestoque      = conferencia.descestoque;
                vself.elstitens 		= conferencia.itens;
                $('#mdlefetivacao').modal('show');
            },
            mtdarquivoconferencia() {
                //limpa o arquivo do input file
                const file               = document.querySelector('#btselecionararquivo');
                file.value               = '';
                this.vnomearquivo        = '';
                ///////////////////////////////
                $('#btselecionararquivo').trigger('click');
            },            
            mtdrotinaferencia(){
                let vself = this;                
                
                let varquivo                = document.getElementById("btselecionararquivo").files[0];
                vself.vnomearquivo          = varquivo.name;

                let extarq = varquivo.name.substring(varquivo.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.$toastr.w("O arquivo selecionado não possui formato válido!", 'Atenção!');
                }else{ 
                    let loader      = vself.$loading.show();
                    let localsalvar = vself.$store.state.configpaths.pathconferencias + vself.$store.state.filialpadrao.idcliente;

                    let parametros      = [
                        {parametro: 'arquivo',          valor  : varquivo},
                        {parametro: 'localsalvar',      valor  : localsalvar},
                        {parametro: 'nomearquivo',      valor  : varquivo.name}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            $('#btselecionararquivo').val('');
                            vself.mtdprocessararquivo(vself.$store.state.configpaths.pathconferencias + vself.$store.state.filialpadrao.idcliente+'/'+vself.vnomearquivo)
                        }else{
                            $('#btselecionararquivo').val('');
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                        $('#btselecionararquivo').val('');
                    });
                }
            },
            mtdprocessararquivo(arquivo, idconta){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'processararquivo'},
                    {parametro: 'arquivo',      valor : arquivo}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadconferencias.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.status)){
                        vself.lstitens = [];
                        vself.lstitensnaoencontrados = [];
                        vself.lstitens = response.data.encontrados;
                        if (response.data.naoencontrados.length > 0){
                            vself.lstitensnaoencontrados = response.data.naoencontrados;
                            $('#mdlnaoencontrados').modal('show');
                        }
                    }else{
                        vself.lstitens = [];
                        vself.lstitensnaoencontrados = [];
                        vself.$toastr.e(response.data.status, 'Erro!');
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdbaixarmatriz(){
                window.open('https://www.rillsoft-app.cloud/controller/arquivosimportacao/manager/matrizes/matrizimportarestoque.xls', '_blank');
            },			                        
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                     
                    if (util.opcaousuario('010Z.030Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtddefinial();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.videstoque === null || this.lstitens.length === 0;
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
            selecionaperiodo: function () {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
			}
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregaconferencias(val);
            },
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddig = val;
					this.mtdlocalizarproduto(this.vcoddig);					
                }
			}
        }
    }
</script>
<style>
.def-col-opcoes-conferencia{
    width : 180px!important;
}
.def-col-cod{
    width : 70px!important;
}
.def-col-descricao{
    width : 300px!important;
}
.def-col-descestoque{
    width : 100px!important;
}
.def-col-dtinicio{
    width : 200px!important;
}
.def-col-situacao{
    width : 120px!important;
}
.def-col-finalizacao{
    width : 200px!important;
}
.def-col-nomeusu  {
    width : 200px!important;
}
#dv-btn-camera{
		display: none;
}
#edidproduto{
    border-top-left-radius: 4px!important;
    border-bottom-left-radius: 4px!important;	        
}
@media screen and (max-width: 767px) {
    #dv-btn-camera{
        display: block;
    }
    #edidproduto{
		border-top-left-radius: 0px!important;
		border-bottom-left-radius: 0px!important;	        
    }
}
</style>